import QrCode from './index.vue';

export default QrCode;
